if (!customElements.get('subscription-button-back')) {
  customElements.define(
    'subscription-button-back',
    class SubscriptionButton extends HTMLElement {
      #selectorButton = 'button';
      #selectorWrapperProduct = '.product--wrapper';
      #selectorWrapperSubscription = '.subscription-info--wrapper';

      constructor() {
        super();
        this.wrapperProduct = document.querySelector(
          this.#selectorWrapperProduct
        );
        this.wrapperSubscription = document.querySelector(
          this.#selectorWrapperSubscription
        );
        this.button = this.querySelector(this.#selectorButton);
        this.button.addEventListener('click', this.showProduct.bind(this));
      }

      showProduct(evt) {
        evt.preventDefault();
        this.wrapperProduct.classList.remove('hidden');
        this.wrapperSubscription.classList.add('hidden');
        window.scrollTo(0, 0);
      }
    }
  );
}
